import React from "react";
import "./Home.css";

import {
  Trekendshi,
  SectionTwoHome,
  MapSection,
  QethjeLarje,
  Footer,
  NewCarousel,
} from "../../Components/index.js";

const Home = () => {
  return (
    <div id="faqja-home">

      <Trekendshi />

      <SectionTwoHome />
      <QethjeLarje />
      <MapSection />
      <Footer/>
    </div>
  );
};

export default Home;
